import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'apps/portal/src/environments/environment';

@Pipe({
  name: 'CMSAsset'
})
export class CMSAssetPipe implements PipeTransform {
  transform(value: any): any {
    const assetURL = environment.configCMS.endPointAssets + value;
    return assetURL;
  }
}
